<template>
  <div class="sign-in">
    <v-container>
      <v-row justify="center" class="my-0">
        <SingleSignOnForm
          v-if="isSingleSignOn"
          @singleSignOn="singleSignOn"
          @singleSignOnEmsOnly="singleSignOnEmsOnly"
        />
        <SignInForm v-else v-bind.sync="user" :loading.sync="loading" @submit="signIn" />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Env } from '@/plugins/env'
import SingleSignOnForm from '@/components/organisms/common/form/SingleSignOnForm'
import SignInForm from '@/components/organisms/common/form/SignInForm'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'SignIn',

  mixins: [APIUtils, Message],

  components: {
    SingleSignOnForm,
    SignInForm,
  },

  data() {
    return {
      user: {
        userCd: '',
        password: '',
      },
      loading: false,
    }
  },

  computed: {
    isSingleSignOn: {
      get() {
        return Env.isSingleSignOn()
      },
    },
  },

  methods: {
    async singleSignOn() {
      await this.$store.dispatch('doSetLoginType', { isEMSOnly: false })
      await this.setRedirectUrl()
      window.location.href = process.env.VUE_APP_COGNITO_HOSTED_UI_URI
    },
    async singleSignOnEmsOnly() {
      await this.$store.dispatch('doSetLoginType', { isEMSOnly: true })
      await this.setRedirectUrl()
      window.location.href = process.env.VUE_APP_EMS_COGNITO_HOSTED_UI_URI
    },
    async signIn() {
      this.loading = true
      try {
        await this.$store.dispatch('doSignIn', { username: this.user.userCd, password: this.user.password })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0001')))
        return
      } finally {
        this.loading = false
      }

      await this.setRedirectUrl()
      this.$router.push({ name: 'TopMenu' }).catch(() => {})
    },
    async setRedirectUrl() {
      await this.$store.dispatch('doSetRedirectUrl', { redirectUrl: this.$route.query.redirect })
    },
  },
}
</script>
